export default "__VITE_ASSET__BsrBKeGl__"